import { MultiSelectFilter } from 'components/multi-select-filter';
import { State } from 'types/api-responses';

const StateFilter = ({
  selectedStates,
  onChange,
  states,
  loading,
  error,
  onRefetch,
}: {
  selectedStates: string[];
  onChange: (abbreviations: string[]) => void;
  states: State[];
  loading: boolean;
  error: string | null;
  onRefetch?: () => void;
}) => (
  <MultiSelectFilter
    id="state-multiselect"
    testIdPrefix="state-filter"
    items={states}
    getKey={(state) => state.abbreviation}
    selectedKeys={selectedStates}
    onChange={onChange}
    title="States"
    label="Select States"
    manyLabel={(count) => `${count} states`}
    errorLabel="Error fetching states"
    loading={loading}
    error={error}
    onRefetch={onRefetch}
    refetchHint="Click to refetch the states"
  />
);

export default StateFilter;
